import React from "react";
import ls from "localstorage-slim";
import { useNavigate, useLocation } from "react-router-dom";

const getInputEmail = () => String(ls.get("inputEmail"));

const Loader = () => {
    const navigate = useNavigate();
    const trackid = getInputEmail();
    console.log("trackid", trackid);
    console.log("hreffff", window.location.href)
    if (window.location.href.includes("/loader")) {
        setTimeout(() => {
            // navigate("/buttons/" + ls.get("inputEmail"))
            window.location.href = window.location.origin + "/buttons/" + getInputEmail()
        }, 5500);
    }
    return (
        <div className="loader_super_wrapper">
            <div className="loader_wrapper outerLoadIframe">
                <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                <div className="card-info text-center mb-3">
                    <div className="card-info text-center">
                        <h6 className="card-title w-75 mx-auto mb-0 lh-base ng-binding"> Redirecting </h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Loader;
